import {
    IDatasetTypeMetadata,
    IDynamicDatasetTypeMetadata
} from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { oracleDatasetMetadata } from './oracle-table-metadata';
import { getOracleCopySourceControls } from '../consts/metadata-consts';
import { format } from 'app/shared/utils/string.util';

export const amazonRdsForOracleDatasetMetadata: IDynamicDatasetTypeMetadata = async (injector) => {
    const metadata: IDatasetTypeMetadata = {
        ...(await oracleDatasetMetadata(injector)),
        type: adfModelTypeMap.amazonRdsForOracle.datasetType,
        supportLinkedServiceTypes: [adfModelTypeMap.amazonRdsForOracle.linkedServiceType],
        displayName: stringResources.AmazonRdsForOracle_DisplayText,
        queryTooltipLink: 'https://aka.ms/amazon_rds_for_oracle_querytips',
        isSink: false,
        icon: {
            className: 'svg-i-100x100-aws_redshift'
        },
        showWarningMessage: '{ linkedService && linkedService.version !== "v2" }',
        warningMessage: format(
            stringResources.Dataset_Legacy_IsNotSupportedWarning_alt3,
            stringResources.VersionLabel.toLocaleLowerCase()
        ),
        warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-amazon-rds-for-oracle',
        v1SupportSchema: undefined,
        copySourceControls: getOracleCopySourceControls(adfModelTypeMap.amazonRdsForOracle.copySourceType),
        copySinkControls: undefined,
        supportDataFlowSink: false,
        supportDataFlowSource: false,
        copyJob: {
            multipleQuery: true,
            sourcePartition: {
                supportSourcePartition: true,
                onlyInteger: true
            }
        }
    };

    return metadata;
};
